import React, { useState, useContext } from 'react'
import { useLocation, useHistory } from 'react-router-dom'
import Button from '@material-ui/core/Button'

// utils
import { getBaseUrl } from '../utils'

// layout
import Layout from '../layout'

// components
import Phone from '../components/fields/Phone'

// styles
import { useStyles } from '../styles/common.style'

// global state
import { Context } from '../store'
import types from '../store/types'

// API
import { getUserBooking } from '../API'

import { t } from 'application-translator/dist/translate/translate.react.js';

function HereNow() {
  const classes = useStyles()
  const { globalState, dispatch } = useContext(Context)
  const { phone, clubId } = globalState.userData || {}
  const { placeData } = globalState.clubData || {};

  // router hooks
  const location = useLocation()
  const history = useHistory()

  // local state
  const [error, setError] = useState(false)

  // callbacks
  const handlePhoneCallback = (data) => {
    const { value, error, countryCode: country } = data || {}
    const countryCode = country?.countryCode?.toUpperCase()
    dispatch({
      type: types.UPDATE_USER_DATA,
      payload: { countryCode, phone: value },
    })
    setError(error)
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    if (!phone) {
      setError(true)
      return
    }

    if (error) return

    callApi()
  }

  // api call...
  const callApi = async () => {
    // show loading
    dispatch({ type: types.SET_LOADING, payload: true })

    // redirect to next page after api call
    // if can't find booking for the phone redirect to sorry page else go to final step
    const res = await getUserBooking({
      phone,
    })
    const result = res.length > 0
    const { pathname } = location
    const baseUrl = getBaseUrl(pathname)
    let redirectPath = 'no-booking'

    // hide loading
    dispatch({ type: types.SET_LOADING, payload: false })

    if (result) {
      // update user data value
      const { email: signedEmail, name: signedBy, phone } = res[0]
      dispatch({
        type: types.UPDATE_USER_DATA,
        payload: {
          signedEmail,
          signedBy,
          phone,
          club_id: clubId,
          clubUserAgreementId: globalState.clubUserAgreementId,
          agreed: 1,
        },
      })
      redirectPath = 'final'
    }
    history.push(`${baseUrl}/${redirectPath}`)
  }

  return (
    <Layout title={t('I\'m here now')}>
      <form
        className={classes.content}
        action="#"
        method="POST"
        onSubmit={handleSubmit}
      >
        <p>{t('Please enter your phone number:')}</p>
        <div className={classes.grp}>
          <Phone
            callback={handlePhoneCallback}
            initValue={phone}
            error={error}
            autoFocus
            countryCode={placeData?.country?.iso_code?.toLowerCase() || 'au'}
          />
          <Button variant="contained" color="primary" type="submit">
            {t('Submit')}
          </Button>
        </div>
      </form>
    </Layout>
  )
}

export default HereNow
